import { Component, Inject, AfterViewInit, ViewChild, ElementRef, Renderer2, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-customer-preview-dialog',
  templateUrl: './customer-preview-dialog.component.html',
  styleUrls: ['./customer-preview-dialog.component.scss']
})
export class CustomerPreviewDialogComponent implements AfterViewInit {
  @ViewChild('dialogContent', { static: false }) dialogContent!: ElementRef<HTMLDivElement>;

  constructor(
    public dialogRef: MatDialogRef<CustomerPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { htmlContent: string },
    private renderer: Renderer2, private cdr: ChangeDetectorRef
  ) {


  }

  ngOnInit(): void {
this.validatingDataSectionWise();
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.dialogContent && this.dialogContent.nativeElement) {
        this.dialogContent.nativeElement.scrollTop = 0;
        const elements = this.dialogContent.nativeElement.querySelectorAll('*');
        elements.forEach((el: Element) => {
          this.renderer.setStyle(el, 'max-width', '100%');
        });
        const cardContent = this.dialogContent.nativeElement.querySelectorAll('.card-content');
        cardContent.forEach((content: Element) => {
          this.renderer.setStyle(content, 'padding-left', '10px');
        });
        this.renderer.setStyle(this.dialogContent.nativeElement, 'overflow-x', 'hidden');
      }
    }, 0);
  }

  close(): void {
    this.dialogRef.close();
  }

  validatingDataSectionWise() {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = this.data.htmlContent;
    const sectionMap: { [key: string]: string } = {
      '#add-work-experience': '#work-experience',
      '#add-education-details': '#education',
      '#add-skill-set-details': '#skill-set',
      '#add-certification-details': '#certifications',
      '#add-speciality-details': '#specialities',
      '#add-publication-details': '#publications',
      '#add-awards-honors': '#awards',
      '#add-associations-organizations': '#associations',
      '#add-volunteering-causes': '#volunteering',
      '#add-courses-training': '#courses',
      '#add-resume': '#resume',
      '#edit-icon': '#edit-icon',
      '#add-icon': '#add-icon',
      '#edit-icon2': '#edit-icon2',
      '#edit-icon3': '#edit-icon3',
      '#edit-icon4': '#edit-icon4',
      '#add-icon4': '#add-icon4',
      '#edit-icon5': '#edit-icon5',
      '#add-icon5': '#add-icon5',
      '#edit-icon6': '#edit-icon6',
      '#edit-icon7': '#edit-icon7',
      '#add-icon7': '#add-icon7',
      '#edit-icon8': '#edit-icon8',
      '#add-icon8': '#add-icon8',
      '#edit-icon9': '#edit-icon9',
      '#add-icon9': '#add-icon9',
      '#edit-icon10': '#edit-icon10',
      '#add-icon10': '#add-icon10',
      '#edit-icon11': '#edit-icon11',
      '#add-icon11': '#add-icon11',
      '#edit-icon12': '#edit-icon12',
      '#add-icon12': '#add-icon12',
      '#edit-icon13': '#edit-icon13',
      '#add-icon13': '#add-icon13',
      // '#social-media-links': '#social-media-links',
    };

    const hideSection = (buttonId: string, sectionId: string) => {
      if (tempDiv.querySelector(buttonId)) {
        const section = tempDiv.querySelector(sectionId);
        if (section) {
          section.classList.add('hide-section');
        }
      }
    };
    Object.entries(sectionMap).forEach(([buttonId, sectionId]) => {
      hideSection(buttonId, sectionId);
    });
    this.data.htmlContent = tempDiv.innerHTML;
    this.cdr.detectChanges();
  }
  
}
